module.exports = __webpack_public_path__ + "img/look-detail.67800228.png";